exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* ORDER REVISION COMPONENT STYLES\n*/order-revisions-warning .alert{margin:10px 0;padding:15px}a{text-decoration:underline}a.active,a.active:hover,a.active:link,a.active:visited{color:#000;cursor:default;text-decoration:none}ul{padding-left:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./core/order-revisions/order-revisions-warning.useable.scss
// module id = 627
// module chunks = 0